import { createTheme } from "@mui/material/styles";

export const lightTheme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#FC4C02",
    },
    secondary: {
      main: "#32C2AC",
    },
    success: {
      main: "#1CC200",
    },
    error: {
      main: "#ef5350",
    },
    warning: {
      main: "#ffa726",
    },
    info: {
      main: "#51534A",
    },
  },
});

export const darkTheme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: "#FC4C02",
    },
    secondary: {
      main: "#32C2AC",
    },
    success: {
      main: "#1CC200",
    },
    error: {
      main: "#ef5350",
    },
    warning: {
      main: "#ffa726",
    },
    info: {
      main: "#51534A",
    },
  },
});
